import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const DeletionContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 2rem 1rem;
  line-height: 1.6;
  color: var(--text-primary);
`;

const Title = styled.h1`
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  color: var(--text-primary);
`;

const Section = styled.section`
  margin-bottom: 2rem;
`;

const Paragraph = styled.p`
  margin-bottom: 1rem;
  color: var(--text-secondary);
`;

const StepList = styled.ol`
  margin-left: 1.5rem;
  margin-bottom: 1rem;
  color: var(--text-secondary);
  
  li {
    margin-bottom: 0.5rem;
  }
`;

const ContactInfo = styled.div`
  background-color: var(--bg-secondary);
  padding: 1.5rem;
  border-radius: 0.5rem;
  margin-top: 2rem;
`;

const DataDeletionPage = () => {
  const { t } = useTranslation();
  const methods = t('dataDeletion.methods', { returnObjects: true });
  const deletedItems = t('dataDeletion.deletedItems', { returnObjects: true });

  return (
    <DeletionContainer>
      <Title>{t('dataDeletion.title')}</Title>

      <Section>
        <Paragraph>{t('dataDeletion.intro')}</Paragraph>
      </Section>

      <Section>
        <h2>{methods.settings.title}</h2>
        <StepList>{methods.settings.steps.map((step) => <li key={step}>{step}</li>)}</StepList>
      </Section>

      <Section>
        <h2>{methods.support.title}</h2>
        <Paragraph>{methods.support.intro}</Paragraph>
        <ContactInfo>
          <Paragraph>
            <strong>{t('dataDeletion.emailLabel')}</strong> support@flea-marketplace.com<br />
            <strong>{t('dataDeletion.subjectLabel')}</strong> {methods.support.subject}<br />
            <strong>{t('dataDeletion.includeLabel')}</strong> {methods.support.include}
          </Paragraph>
          <Paragraph>{methods.support.processingTime}</Paragraph>
        </ContactInfo>
      </Section>

      <Section>
        <h2>{t('dataDeletion.deletedTitle')}</h2>
        <Paragraph>{t('dataDeletion.deletedIntro')}</Paragraph>
        <ul style={{ marginLeft: '1.5rem', color: 'var(--text-secondary)' }}>
          {deletedItems.map((item) => <li key={item}>{item}</li>)}
        </ul>
        <Paragraph>
          <strong>{t('dataDeletion.noteLabel')}</strong> {t('dataDeletion.note')}
        </Paragraph>
      </Section>

      <Section>
        <h2>{t('dataDeletion.confirmationTitle')}</h2>
        <Paragraph>{t('dataDeletion.confirmation')}</Paragraph>
      </Section>
    </DeletionContainer>
  );
};

export default DataDeletionPage;

